import { useState, useCallback, useEffect } from "react";
import { request } from "./../../httpClient/request";

export const useGetTrip = (user_id?: string) => {
  const [tripList, setTripList] = useState<any>([]);
  const [tripLoading, setTripLoading] = useState<boolean>(false);

  const getTrip = useCallback(async () => {
    try {
      setTripLoading(true);
      const res = await request({
        path: "trip/list",
      });
      if (user_id) {
        // console.log("trips user_id: ", user_id, res.data);
        setTripList(res.data?.filter((t) => t.user_id == user_id));
      } else {
        setTripList(res.data);
      }
      setTripLoading(false);
      return res;
    } catch (e) {
      alert(e);
      setTripList([]);
      setTripLoading(false);
    }
  }, []);

  useEffect(() => {
    getTrip();
  }, []);

  return { tripList, getTrip, tripLoading };
};
